var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Feature.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["f"], 
[], 
function (l_f, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("f", l_f);
var t_2 = "";t_2 += "<li class=\"Feature ";
if(!runtime.memberLookup((l_f),"text")) {
t_2 += "Feature--isNotActive";
;
}
t_2 += "\">\n        <a class=\"Feature-header\">\n            <span class=\"Feature-icon\">\n                ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Feature/Feature.svg")), env.opts.autoescape);
t_2 += "\n            </span>\n            <div class=\"Feature-title\">";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_f),"title")), env.opts.autoescape);
t_2 += "</div>\n        </a>\n\n        <div class=\"Feature-text\">";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_f),"text")), env.opts.autoescape);
t_2 += "</div>\n    </li>";
t_2 += runtime.suppressValue((lineno = 10, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("Feature");
context.setVariable("Feature", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["Feature.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Feature/Feature.jinja
// module id = 88
// module chunks = 0